import { render, staticRenderFns } from "./FiltersBar.vue?vue&type=template&id=3f925ef4&scoped=true"
import script from "./FiltersBar.vue?vue&type=script&lang=js"
export * from "./FiltersBar.vue?vue&type=script&lang=js"
import style0 from "./FiltersBar.vue?vue&type=style&index=0&id=3f925ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f925ef4",
  null
  
)

export default component.exports